<template>
    <div>
        <navigation-bar Close/>
        <div class="NewsDetail container main">
            <img :src="articleInfo.imgUrl">
            <el-row type="flex" justify="space-between" class=" mt-3">
                <!--todo 有tag狀態下樣式加active-->
                <i class="tag-store"></i>
                <p class="date2">{{articleInfo.releaseAt}}</p>
            </el-row>

            <h3>{{ articleInfo.name }}</h3>
            <el-row type="flex" justify="space-between" class=" mt-3">
                <p class="date2">{{ articleInfo.brandTitle }}</p>
                <p class="date2">{{ articleInfo.author}}</p>
            </el-row>


            <div class="btn-function-list">
                <!--TODO 按喜歡後增加樣式 active-->
                <el-button type="text" class="heart" v-if="showHidden"><i/>{{ articleInfo.loveCount }}</el-button>

                <!--TODO 分享-->
                <!--<el-button type="text" class="share" @click="ShareModal = true">
                    <img src="@/assets/images/share.svg">888
                </el-button>-->

                <div class="text-right" v-if="showHidden">
                    <!--TODO 留言-->
                    <el-button type="text" class="message" @click="messageBlock=!messageBlock">
                        <img src="@/assets/images/message.svg">{{ articleInfo.replyCount }}
                    </el-button>

                    <span class="ml-2 pageviews">瀏覽 {{ articleInfo.watchCount }}</span>
                </div>

            </div>
            <el-divider></el-divider>

            <div class="message-block mt-4" v-if="messageBlock">

                <!--TODO 留言區塊-->
                <Message :messageList="messageList" @message-reply="messageReply" @message-confirm="messageConfirm"/>

                <!--todo 沒有留言狀態-->
                <div class="no-data" v-if="messageList.length === 0">
                    沒有留言
                </div>

            </div>

            <div class="text-content">
                <div v-html="articleInfo.content"></div>
            </div>

            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true">
            </loading>

        </div>
    </div>
</template>


<script>
    //import NewsFunction from '@/components/NewsFunction.vue'
    import Message from '@/components/Message.vue'
    import {notNull} from "../../util/common";

    export default {
        name: "ArticlePage",
        components: {
            //NewsFunction,
            Message,
        },
        data() {
            return {

                id: this.$route.query.id,
                isLoading: false,
                ShareModal: false,//分享文章彈框
                messageBlock: false,//留言區塊
                ReportModal: false,//檢舉留言彈框
                showHidden: false,

                articleInfo: {
                    id: 0,
                    name: '',
                    content: '',
                    brandName: '',
                    storeName: '',
                    imgUrl: '',
                    createdAt: '',
                    isFavor: false,
                    watchCount: 0,
                    replyCount: 0,
                    loveCount: 0,
                    releaseAt: '',
                },

                replyAry: {
                    content: '',
                    loveCount: 0,
                    createdAt: '',
                    nickName: '',
                    picture: '',
                    isLove: false,
                    replyList: {},
                },

                messageList: {},
            }
        },
        created() {
            this.getArticleInfo();
        },
        mounted() {

        },
        methods: {
            getArticleInfo: function () {
                let self = this;
                this.isLoading = false;
                this.$http.fetch`HotArticleInfoById${{
                    id: self.$route.query.id,
                }} ${json => {
                    self.isLoading = false;

                    if (notNull(json.data)) {
                        self.articleInfo = json.data;

                        //新增品牌店名標題
                        self.articleInfo.brandTitle = `${self.articleInfo.brandName?self.articleInfo.brandName:''}${self.articleInfo.brandName?'-':''}${self.articleInfo.storeName}`;

                        self.watchCount = json.data.watchCount;
                        self.messageList = json.data.replyAry;
                    }

                }}`;

                if (notNull(self.messageList.replyList)) {
                    self.messageList['replyCount'] = self.messageList.replyList.length;
                } else {
                    self.messageList['replyCount'] = 0;
                }

            },
            messageReply: function (arg) {
                let self = this;
                this.isLoading = true;
                this.$http.fetchWithAuth`ReplyOinActivityAnnouncementListMessage${{
                    'id': parseInt(arg.id),
                    'content': arg.message,
                }}
                ${json => {
                    self.isLoading = false;
                    self.$public.showNotify(json.message, json.status);
                    if (json.status) {
                        self.setupData();
                    }
                }}`;
            },
            messageConfirm: function (message) {
                let self = this;
                this.isLoading = true;
                this.$http.fetchWithAuth`ReplyOinActivityAnnouncementList${{
                    'id': parseInt(self.id),
                    'content': message,
                }}
                ${json => {
                    self.isLoading = false;
                    self.$public.showNotify(json.message, json.status);
                    if (json.status) {
                        self.setupData();
                    }
                }}`;
            },

        }
    }
</script>

<style lang="less" scoped>
    .NewsDetail{
        img{
            border: 1px solid #eee;
        }
    }
</style>